import { css } from "@emotion/react";

// Global color codes
export const WB_GREEN = "#27ce0a";
export const MSG_SUCCESS = "#E9FFF0"; // message success
export const MSG_ERROR = "#FFF4E5"; // message error
export const RSS_FEED_MODAL_Z_INDEX = 1030; // for rss feed modal on design screen

// Global styles
export const GRID_LOADER_CSS = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;
export const GRID_LOADER_SMALL = css`
  display: block;
  margin: 0 auto;
  border-color: red;
  position: absolute;
  top: 10px;
  right: 30px;
`;
